import { NavigatorScreenParams } from '@react-navigation/native';
import { lazy } from 'react';
import { centerModalOption } from '../../appComponents/ModalWrapper';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';
import type { AuthFlowScreenParams } from './components/AuthFlowPageContent';

const AuthFlowPageContent = lazy(
  () => import('./components/AuthFlowPageContent'),
);

const AuthFlowPage = wrapLazyNavigatorScreen(
  (
    props: NavigatorScreenParams<AuthFlowScreenParams> & {
      onCreated?: () => void;
      onClosed?: () => void;
    },
  ) => {
    return <AuthFlowPageContent {...props} />;
  },
  centerModalOption,
);

export default AuthFlowPage;
